import { datadogRum } from '@datadog/browser-rum';

import { type AddActionFn } from './addAction.types';

// https://docs.datadoghq.com/real_user_monitoring/guide/send-rum-custom-actions/?tab=npm#instrument-your-code
export const addAction: AddActionFn = (name, context, _type) => {
  datadogRum.addAction(name, context);
};
